var _require = require("./package.json"),
  version = _require.version;
var lastRequestId = -1;
function wrapAutoseg(urlOrVersion) {
  try {
    if (urlOrVersion.match(/^[0-9]+\.[0-9]+\.[0-9]+$/)) {
      urlOrVersion = "https://unpkg.com/autoseg@".concat(urlOrVersion, "/webworker-worker-bundle.js");
    }
    var blob = new Blob(["importScripts('".concat(urlOrVersion, "')")], {
      type: "application/javascript"
    });
    var blobUrl = window.URL.createObjectURL(blob);
    var webworker = new Worker(blobUrl);

    // This is blocked by a unfixable CORS error
    // const webworker = new Worker(urlOrVersion)

    var functions = ["setConfig", "loadImage", "getMask"];
    var obj = {};
    var _loop = function _loop() {
      var functionName = _functions[_i];
      var id = lastRequestId++;
      obj[functionName] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        webworker.postMessage({
          functionName: functionName,
          args: args,
          id: id
        });
        return new Promise(function (resolve, reject) {
          var possibleResponse = function possibleResponse(e) {
            var data = e.data;
            if (!data) return;
            if (data.id === id) {
              webworker.removeEventListener("message", possibleResponse);
              if (data.error) {
                reject(new Error(data.error));
              } else {
                // There's some issue with the serialization of the ImageData
                // for getMask
                if (functionName === "getMask") {
                  var _data$returnValue = data.returnValue,
                    pixels = _data$returnValue.data,
                    width = _data$returnValue.width,
                    height = _data$returnValue.height;
                  resolve(new ImageData(pixels, width, height));
                } else {
                  resolve(data.returnValue);
                }
              }
            }
          };
          webworker.addEventListener("message", possibleResponse);
        });
      };
    };
    for (var _i = 0, _functions = functions; _i < _functions.length; _i++) {
      _loop();
    }
    return obj;
  } catch (e) {
    console.log("error loading autoseg: ".concat(e.toString()));
    return {};
  }
}
module.exports = wrapAutoseg("https://unpkg.com/autoseg@".concat(version, "/webworker-worker-bundle.js"));
module.exports.wrapAutoseg = wrapAutoseg;